import {call, put, takeLatest, all, select} from 'redux-saga/effects'
import {initialize, getFormValues} from 'redux-form'
import actionTypes from '../../constants/actions/FDA/FDA'
import {dateTimeZones} from '../../util/formatFunctions'
import getExportarArchivos from '../../services/FDA/getExportarArchivos'


export function* fetchExportarArchivos({ values }) {
  try {
    const auth = yield select(state => state.auth);

    // Usamos fetch directamente para asegurar el manejo del BLOB
    const response = yield call(fetch, `${process.env.REACT_APP_API_URL}/FDA/getExportarArchivos`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.token}`
      },
      body: JSON.stringify(values)
    });

    if (!response.ok) throw new Error('Error al descargar el archivo');

    // CONVERTIR LA RESPUESTA A BLOB
    const blob = yield response.blob();

    // CREAR EL ENLACE DE DESCARGA
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    
    // Asignar nombre al archivo
    link.setAttribute('download', 'logs_fda.zip');
    
    document.body.appendChild(link);
    link.click();

    // LIMPIEZA
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Error en la descarga:", error);
    // Aquí podrías disparar una acción de error para mostrar un mensaje al usuario
  }
}
export function * watchExportarArchivos () {
  yield takeLatest(actionTypes.EXPORTAR_ARCHIVOS, fetchExportarArchivos)
}


